import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Button} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useAddToCartModalContext} from '../../../hooks/use-add-to-cart-modal'
import {useShopperBasketsMutationHelper} from '@salesforce/commerce-sdk-react'
import {useToast} from '../../../hooks/use-toast'
import {API_ERROR_MESSAGE} from '../../../constants'
import {noop} from '../../../utils/utils'
import Link from '@salesforce/retail-react-app/app/components/link'

const AddWarrantyToCartButton = ({
    product,
    parentProductId,
    callback = noop,
    selectedWarrantyVariantId,
    setWarrantyError,
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const {data: modalData} = useAddToCartModalContext()
    const showToast = useToast()
    const intl = useIntl()

    const handleAddToCart = async (e) => {
        e.stopPropagation()
        if (!selectedWarrantyVariantId) {
            setWarrantyError(true)
            return
        }
        setIsLoading(true)

        try {
            const productItem = {
                productId: product.productId,
                quantity: 1,
                c_isWarranty: true,
                c_parentProductId: parentProductId || modalData?.itemsAdded?.[0]?.product?.id,
            }

            const result = await addItemToNewOrExistingBasket([productItem])

            if (result) {
                setTimeout(() => {
                    callback(product)
                }, 1500)
            }
        } catch (error) {
            console.error('Error adding warranty to cart:', error)
            showToast({
                title: intl.formatMessage(API_ERROR_MESSAGE),
                status: 'error',
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Button
            data-testid="add-warranty-to-cart-button"
            w="full"
            as={selectedWarrantyVariantId ? Link : Button}
            to={selectedWarrantyVariantId ? '/cart' : undefined}
            onClick={handleAddToCart}
            isLoading={isLoading}
            isDisabled={isLoading}
            variant="primary"
        >
            <FormattedMessage
                id="global.add-warranty-to-cart"
                defaultMessage="Aggiungi De'Longhi Care"
            />
        </Button>
    )
}

AddWarrantyToCartButton.propTypes = {
    product: PropTypes.shape({
        productId: PropTypes.string.isRequired,
    }).isRequired,
    parentProductId: PropTypes.string,
    callback: PropTypes.func,
    selectedWarrantyVariantId: PropTypes.string,
    setWarrantyError: PropTypes.func,
}

export default AddWarrantyToCartButton
